import React from 'react'
import CompareProducts from './compare-products'

export const ComparePage: React.FC = () => {
  return <CompareProducts />
}
